import { render, staticRenderFns } from "./Mot.vue?vue&type=template&id=2e7136c6&scoped=true"
import script from "./Mot.vue?vue&type=script&lang=js"
export * from "./Mot.vue?vue&type=script&lang=js"
import style0 from "./Mot.vue?vue&type=style&index=0&id=2e7136c6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7136c6",
  null
  
)

export default component.exports